import styled from 'styled-components';
import { device } from '../../styles/variables';

const Screen = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  ${({ background }) => `
    background: ${background || 'none'};
  `};
  min-height: 952px;
  @media ${device.tablet} {
    min-height: 800px;
  }

  &.larger-screen {
    @media ${device.tablet} {
      min-height: 1000px;
    }
  }
`;

const SplitScreen = styled.div`
  ${({ background, opacity }) => `
    width: 50%;
    display: inline-block;
    // overflow: hidden;
    background: ${background || 'none'};
    opacity: ${opacity || '1'};
  `};
`;

const SplitScreenContentHolder = styled.div`
  position: relative;
  max-width: 640px;
  height: 100%;
  width: 100%;
  ${({ direction }) => `
    float: ${direction || 'none'};
  `};
`;

export { Screen, SplitScreen, SplitScreenContentHolder };



// WEBPACK FOOTER //
// ./src/components/Layout/Screen.jsx